import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { normalizeEntrypointConfig } from '@/lib/adapters/entrypoint.adapter'
import { request } from '@/lib/services'
import type { EntrypointConfig, EntrypointConfigRaw } from '@/types/entrypoint'

export const useEntrypointStore = defineStore('entrypoint', () => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)
  const config = ref<EntrypointConfig>()

  const hasCampaigns = computed(() => config.value?.hasCampaigns)
  const hasInvoices = computed(() => config.value?.hasInvoices)

  const fetchConfig = async (storeId: number) => {
    isLoading.value = true
    error.value = null
    try {
      const response = await request.get<EntrypointConfigRaw>('v2/entrypoint', {
        params: { store_id: storeId, app: 'advertiser' },
      })
      config.value = normalizeEntrypointConfig(response.data)
    } catch (err) {
      error.value = err as Error
    } finally {
      isLoading.value = false
    }
  }

  return {
    config,
    hasCampaigns,
    hasInvoices,
    isLoading,
    error,
    fetchConfig,
  }
})
